module.exports = __webpack_public_path__ + "img/item3.9f79250a.png";